{
  "version": 1,
  "asset_id": "d1b39c13-54d1-4523-9411-ef59f0ec4fce",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/d1b39c13-54d1-4523-9411-ef59f0ec4fce/hero-6-de-abril-poster.jpg",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/d1b39c13-54d1-4523-9411-ef59f0ec4fce/hero-6-de-abril-poster.jpg",
  "original_filename": "hero-6-de-abril-poster.jpg",
  "size": 23257,
  "content_type": "image/jpeg",
  "created_at": "2026-11-04T13:09:20Z"
}
